import { useAppUserAuth } from 'global/cnr/contexts/useHelpers/useAppUserAuth';
import { useFileImage } from 'global/cnr/contexts/useHelpers/useFileImage';
import { useProfiles } from 'global/cnr/contexts/useHelpers/useProfiles';
import { _allowUpload, useUpload } from 'global/cnr/contexts/useHelpers/useUpload';
import { showAppManagementTypes } from 'global/cnr/reducers/AppUserManagementReducer';
import { MonthCalendars } from 'global/components/calendar/MonthCalendar';
import { AppDashboardContext } from 'global/components/viewers/AppDashboardOptions';
import { appIconTypes } from 'global/enums/appIconTypes';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Icon, Image, Label } from 'semantic-ui-react';
import { AppUserManagementContext } from '../cnr/contexts/AppUserManagementContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { TopicContext } from '../cnr/contexts/TopicContext';
import { getAlphaList } from '../common/convert';
import { uniqueKey } from '../common/keys';
import UiSaveButtons from '../components/buttons/UiSaveButtons';
import AlphabetMenuWithProvider from '../components/menus/AlphabetMenu';
import { gEnums } from '../enums/globalEnums';
import UiSearchFilter from '../pageItem/UiSearchFilter';
import ConfirmationWrapper from '../wrappers/ConfirmationWrapper';
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper';
import WrapperVertCols from '../wrappers/WrapperVertCols';
import AppUserCard from './AppUserCard';
import AppUserSubManager from './AppUserSubManager';
import { _appUserDashboardTypes, SquaresAppUsers } from './SquaresAppUsers';
// import TeamColors from 'projectSpecific/sports/elements/random/TeamColors';

const _defaultDays = 14
const _alphaTrigger = 60

/**
 * 
 * @param {object} props (items, handleClick, showFound, found)
 * @returns A list of appUsers
 */
const AppUsersDashboard = (props) => {

  const { fromDataViewer, handleCancel, handleClick, showFound, found, viewOnly } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { app_state, appSettings_state, storage_state, appUsersAuth_state, paps_state, currentSettings_state } = states ?? {}
  const { appUser_handlers, appUsersAuth_handlers, appSettings_handlers } = handlers ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, appUserViewTypeProp } = aps_appUserSettings ?? {}
  const { appUserAuthList, appUserAuthUsageData } = appUsersAuth_state ?? {}
  const { authOn } = appSettings_state ?? {}
  const { appStorageUrlFiles } = storage_state ?? {}
  const _clientProfilesUrls = appStorageUrlFiles?.[gEnums.storageLocationTypes.clientProfiles]

  const appDashboardContext = useContext(AppDashboardContext);
  const { appDashboard_state } = appDashboardContext ?? {}
  const { isSplit } = appDashboard_state ?? {}

  // appUserManagementContext
  const appUserManagementContext = useContext(AppUserManagementContext)
  const { appUserManagement_state, appUserManagement_handlers } = appUserManagementContext ?? {}
  const { appProfileData } = appUserManagement_state ?? {}
  const { adminProfiles, nonProfiledAttendees, nonEventProfiles, attendeeClientProfiles, clientProfiles, counts_attendee, counts_profile } = appProfileData ?? {}

  const _counts = pathViews.events ? counts_attendee : counts_profile
  const _profiles = pathViews.events ? attendeeClientProfiles : clientProfiles

  // topicContext
  const topicContext = useContext(TopicContext);
  const { topic_state } = topicContext ?? {}

  const [alphaValue, setAlphaValue] = useState(65)
  const [currentAppUser, setCurrentAppUser] = useState()
  const [currentProfiles, setCurrentProfiles] = useState(_profiles)
  const [dayCount, setDayCount] = useState(_defaultDays)
  const [photoDropped, setPhotoDropped] = useState()
  const [selectedAlphaChar, setSelectedAlphaChar] = useState('a')
  const [selectedFilteredDataList, setSelectedFilteredDataList] = useState()
  const [selectedListType, setSelectedListType] = useState()
  const [showConfirmation, setShowConfirmation] = useState()
  const [sortProp, setSortProp] = useState('lastName')
  const [uniqueProps, setUniqueProps] = useState('lastName')

  // use helpers
  const { processing, getAppUserAuths } = useAppUserAuth()
  const { handle_onFileDrop, handleCreate_fileList, fileInfos, handleClear } = useFileImage({ _profiles, forMulti: true })
  const { handleUpload_profiles } = useUpload()
  const { createProfiles, updatingProfiles } = useProfiles()

  const [currentImageFiles, setCurrentImageFiles] = useState()
  const [currentImageDroppedFiles, setCurrentImageDroppedFiles] = useState()

  const handleAppUser = (appUser) => setCurrentAppUser(appUser)

  const draggingImageRef = useRef(null);

  // MEMO
  const showSearch = useMemo(() => {
    switch (selectedListType) {
      case _appUserDashboardTypes.appUsage:
        return false
      default:
        return true
    }
  }, [selectedListType])

  // MEMO
  const { currentData, fullData, showAlpha } = useMemo(() => {
    let _cps = currentProfiles;

    const { recent, found, notFound } = appUserAuthList ?? {}
    if (selectedFilteredDataList) {
      _cps = selectedFilteredDataList
    } else {
      switch (selectedListType) {
        case _appUserDashboardTypes.appUsage:
          break;
        case _appUserDashboardTypes.admins:
          _cps = adminProfiles
          break;
        case _appUserDashboardTypes.total:
          _cps = currentProfiles
          break;
        case _appUserDashboardTypes.recent:
          _cps = recent
          break;
        case _appUserDashboardTypes.found:
          _cps = found
          break;
        case _appUserDashboardTypes.notFound:
          _cps = notFound
          break;
        case _appUserDashboardTypes.nonProfiled:
          _cps = nonProfiledAttendees
          break;
        case _appUserDashboardTypes.photo:
          _cps = _.filter(_cps, item => item.appUserImage);
          break;
        case _appUserDashboardTypes.nonPhoto:
          _cps = _.filter(_cps, item => !item.appUserImage);
          break; f
        case _appUserDashboardTypes.photoSourced:
          _cps = _.filter(_cps, item => item._file);
          break;
        case _appUserDashboardTypes.getFiles:
          _cps = _.filter(_cps, item => item._file);
          break;
        case _appUserDashboardTypes.missingEvent:
          // console.group('ryan.anderson4@yahoo.com 3')
          // console.log('_cps', _cps)
          // console.groupEnd()
          _cps = _.filter(_cps, item => item._hasEvent === false);
          break;
        case _appUserDashboardTypes.missingProfile:
          _cps = _.filter(_cps, item => item._hasProfile === false);
          break;
        case _appUserDashboardTypes.fcm:
          _cps = _.filter(_cps, item => item.fcmTokens);
        default:
          _cps = _cps
      }
    }
    let _currentData = _cps
    const _showAlpha = _.size(_cps) > _alphaTrigger
    if (_.size(_cps) > _alphaTrigger) {
      const { alphaList } = getAlphaList(_cps, selectedAlphaChar, sortProp)
      _currentData = alphaList
    }
    return { currentData: _currentData, fullData: currentProfiles, showAlpha: _showAlpha }
  }, [selectedListType, selectedAlphaChar, photoDropped])

  // MENO
  const itemCount = useMemo(() => {
    if (!_.isEmpty(_profiles)) {
      return _.size(_profiles)
    }
    return 0
  }, [_profiles])

  // EFFECT - modify from _clientProfilesUrls
  useEffect(() => {
    if (!_.isEmpty(_clientProfilesUrls) && _profiles) {
      const _attendeeProfiles = _.mapValues(_profiles, (attendee) => {
        const imageInfo = _clientProfilesUrls[attendee.email];
        return imageInfo?.urls?.thumbnail
          ? { ...attendee, appUserImage: imageInfo }
          : attendee;
      });
      setCurrentProfiles(_attendeeProfiles)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [_clientProfilesUrls, _profiles]);

  // EFFECT - modify from imageFiles (getFiles)
  useEffect(() => {
    if (!_.isEmpty(fileInfos?.imageFiles) || !_.isEmpty(fileInfos?.imageDroppedFiles)) {
      const { imageFiles, imageDroppedFiles } = fileInfos
      const _currentAttendeeProfiles = _.cloneDeep(currentProfiles)
      _.forEach(imageFiles, (imageFile, imageFileKey) => {
        if (_currentAttendeeProfiles?.[imageFileKey]) {
          _currentAttendeeProfiles[imageFileKey]._file = imageFile._file
        }
      })
      setCurrentProfiles(_currentAttendeeProfiles)
      setCurrentImageFiles(imageFiles)
      setCurrentImageDroppedFiles(imageDroppedFiles)
      setSelectedListType(_appUserDashboardTypes.getFiles)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [fileInfos?.imageFiles]);

  useEffect(() => {
    appUserManagement_handlers.handleAmmend_auths(dayCount)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [dayCount]);


  const handleUploadProfileImages = () => {
    const callback = () => {
      console.log('test')
    }
    const uploadPath = `clients/${pathViews.clients}/${'profiles'}`
    const _fileList = _.filter(currentProfiles, item => item._file);
    const fileList = handleCreate_fileList(_fileList)
    handleUpload_profiles({ uploadPath, fileList, useEmail: true, callback })
  }
  // const handle_updateSnapshot = () => {
  //   const cb = (aaa) => {
  //     console.log('aaa', aaa)
  //   }
  //   eventInfo_handlers.handleUpdate_appUserSnapshot(pathViews, appUserAuthList, cb)
  // }



  const handle_removeNonFound = async () => {
    // setUpdatingProfiles(true)
    // await createProfiles(nonProfiledAttendees)
    // setUpdatingProfiles(false)
  }

  const handle_updateNonProfiled = async () => {
    await createProfiles(nonProfiledAttendees)
  }

  const handle_updateNonEvents = async () => {
    await createProfiles(nonEventProfiles)
  }

  const handle_showConfirmation = (opts) => {
    if (!_.isEmpty(opts?.optionType)) {
      setShowConfirmation(opts.optionType)
    } else {
      setShowConfirmation()
    }
  }

  const handleAlphaChange = (av) => {
    const _alphaChar = String.fromCharCode(av)
    setSelectedAlphaChar(_alphaChar)
  }

  const handleSelectedListType = (sl) => setSelectedListType(sl)
  const handleGoToEvent = (e) => e.stopPropagation()

  const handleSignInAs = (e, listItem, _itemKey) => {
    e.stopPropagation()
    const actionItem = { dataActionType: 'clone', cloneId: _itemKey, cloneVit: appUserCollection, appUserViewTypeProp: appUserViewTypeProp }
    appUser_handlers.handleClone(actionItem, listItem, paps_state, appUserCollection)
    handleCancel && handleCancel()
  }

  const handleMenuItemClicker = (itemKey) => {
    console.log('itemKey', itemKey)
  }

  const onDrop = (e, appUser) => {
    if (!appUser) { return; }
    e && e.preventDefault();

    const imageFile = draggingImageRef.current;
    const _appUser = JSON.parse(appUser)

    const { email: email_appUser, _itemKey: _itemKey_appUser } = _appUser ?? {}
    const { _dataItem } = imageFile ?? {}
    const { _itemKey: _itemKey_dropped } = _dataItem ?? {}

    const _currentAttendeeProfiles = _.cloneDeep(currentProfiles)
    const _currentImageFiles = _.cloneDeep(currentImageFiles)

    if (_currentAttendeeProfiles?.[email_appUser]) {
      _currentAttendeeProfiles[email_appUser]._file = imageFile
      setCurrentProfiles(_currentAttendeeProfiles, selectedAlphaChar)
    }
    if (_currentImageFiles?.[email_appUser]) {
      _currentImageFiles[email_appUser]._file = imageFile
      setCurrentImageFiles(_currentImageFiles)
    }
    setPhotoDropped(!photoDropped)
  };

  const hc = (item) => {
    console.log('item', item)
  }

  const appUserCard = (listItem, lblColor, index) => {
    const { appUserImage } = listItem
    const appUserUrl = appUserImage?.urls?.thumbnail
    const appUserFile = listItem?._file
    const appUserSrc = appUserFile?.src
    return <AppUserCard
      key={uniqueKey('aul', index)}
      appUser={listItem}
      appUserUrl={appUserUrl}
      appUserSrc={appUserSrc}
      index={index}
      lblColor={lblColor}
      handleClick={handleClick}
      handleGoToEvent={handleGoToEvent}
      handleSignInAs={handleSignInAs}
      viewOnly={viewOnly}
      uniqueProps={uniqueProps}
      handleMenuItemClicker={handleMenuItemClicker}
      origin={'aud'}
      onDrop={onDrop}
    />
  }

  const getContent = (item) => {
    const lblColor = showFound ? (found ? 'green' : 'red') : undefined;
    return <div style={{ padding: '.5em' }}>
      {appUserCard(item, lblColor, 0)}
    </div>
  }

  const getMatchWithSource = (appUserAuthList, item) => {
    return _.find(
      _.map(appUserAuthList, (arr, type) => {
        const match = _.find(arr, { key: item.key });
        return match ? { ...match, _source: type } : null;
      })
    );
  };
  const appUserCards = useMemo(() => {

    let showHasEvent = true
    let showHasProfile = true
    let showLastRefreshTime = false

    if (selectedFilteredDataList) {
      // _data = selectedFilteredDataList
    } else {
      switch (selectedListType) {
        case _appUserDashboardTypes.getClientProfiles:
          return <AppUserSubManager appManagementType={showAppManagementTypes.getClientProfiles} />
        case _appUserDashboardTypes.appUsage:
          return <MonthCalendars appUserAuthUsageData={appUserAuthUsageData} />
        case _appUserDashboardTypes.admins:
        case _appUserDashboardTypes.recent:
        case _appUserDashboardTypes.found:
          showHasEvent = false
          showHasProfile = false
          showLastRefreshTime = true
          break;
        case _appUserDashboardTypes.notFound:
          showHasEvent = false
          showHasProfile = false
          break;
        case _appUserDashboardTypes.total:
        case _appUserDashboardTypes.nonProfiled:
        case _appUserDashboardTypes.nonPhoto:
        case _appUserDashboardTypes.photoSourced:
        case _appUserDashboardTypes.getFiles:
        case _appUserDashboardTypes.missingEvent:
        case _appUserDashboardTypes.missingProfile:
        case _appUserDashboardTypes.fcm:
          break;
        default:
        // nothing
      }
    }

    const _data_tree = _.orderBy(currentData, ['lastName'])

    const fnsAlt = (item) => {
      const icons = []
      icons.push(<Icon name={appIconTypes.calendar} color={item._hasEvent ? 'green' : 'grey'} title={'Event'} />)
      icons.push(<Icon name={appIconTypes.user} color={item._hasProfile ? 'green' : 'grey'} title={'Profile'} />)
      if (item.email) { icons.unshift(<Icon name={appIconTypes.mail} color='blue' title={'Email'} />) }
      if (item.fcmTokens) { icons.unshift(<Icon name={appIconTypes.pushNotifications} color='orange' title={'FCM Token'} />) }
      if (item.phoneNumber) { icons.unshift(<Icon name={appIconTypes.phone} color='green' title={'Phone'} />) }
      if (item.events) { icons.unshift(<Label style={{ marginRight: '1em' }} circular size='mini' title={'Events'} color={_.isEmpty(item.events) ? 'grey' : 'blue'}>{_.size(item.events)}</Label>) }

      const mls = getMatchWithSource(appUserAuthList, item)
      if (mls?._source && mls?.metadata) {
        const { metadata, _source } = mls
        const { lastRefreshTime, lastSignInTime } = metadata
        let color = 'grey';
        let name = 'circle outline'
        switch (_source) {
          case 'recent':
            color = 'green'
            name = 'check circle'
            break;
          case 'found':
            color = 'blue'
            name = 'check circle'
            break;
          default:
          /// nothing
        }
        icons.unshift(<Label size='mini' style={{ marginRight: '1em' }} >{lastRefreshTime || lastSignInTime || 'Not Found'}</Label>)
        icons.unshift(<Icon name={name} color={color}></Icon>)
      }
      return icons
    }

    const fnsImage = (item) => {
      const _item = currentData?.[item?.email] || item
      const { appUserImage, appUserSrc } = _item ?? {}
      const { urls } = appUserImage ?? {}
      const { thumbnail } = urls ?? {}
      let elem;
      if (appUserSrc) {
        elem = <Image src={appUserSrc} avatar />
      } else if (thumbnail) {
        elem = <Image src={thumbnail} avatar />
      } else {
        elem = <Icon name='user' size='large' color='grey' />
      }
      return <div className='sqr-box-icon'>{elem}</div>
    }

    return <ItemMenuSquares
      menuItems={_data_tree}
      activeItem={currentAppUser?._itemKey}
      imsType={_imsTypes.inline}
      onClick={handleAppUser}
      fn_altContent={fnsAlt}
      fns_image={fnsImage}
    />
  }, [currentAppUser, selectedListType, selectedAlphaChar, photoDropped])

  const handleCheck_auths = async () => {
    const cb = (res, totals, usageData) => {
      appUsersAuth_handlers.handleAmmend_appUserAuthList(res, totals, usageData)
    }
    if (pathViews.events && appProfileData.eventProfiles) {
      getAppUserAuths(cb, appProfileData.eventProfiles)
    } else if (!pathViews.events && appProfileData.clientProfiles) {
      getAppUserAuths(cb, appProfileData.clientProfiles)
    }
  }

  const hc_appUsers = (mt) => {
    setCurrentAppUser()
    handleSelectedListType(mt?.key)
  }

  const hc_options = (mt) => {
    switch (mt?.key) {
      case _appUserDashboardTypes.checkAuthorizations:
        handleCheck_auths()
        break;
      case _appUserDashboardTypes.getClientProfiles:
        handleSelectedListType(mt?.key)
        break;
      case _appUserDashboardTypes.authOn:
        appSettings_handlers.handleToggle_authOn()
        break;
      default:
    }
  }

  const wrapper_appUserCards = () => <Wrapper
    content={appUserCards}
    wrapperType={wrapperTypes.paddedHeader}
  />

  const alphaMenu = () => {

    const grouping = {
      alphaDisplayType: gEnums.alphaDisplayTypes.vertical,
      useVerticalHidden: true,
      verticalOpacity: gEnums.opacityTypes.medium,
      restrictToExisting: true,
    }

    return <AlphabetMenuWithProvider
      origin={'appUserList'}
      dataItems={fullData}
      handleAlphaChange={handleAlphaChange}
      alphaValue={alphaValue}
      restrictToExisting={true}
      sortProp={sortProp}
      grouping={grouping}
    />
  }

  const wrapper_alpha = () => <Wrapper
    alphaMenu={alphaMenu()}
    content={wrapper_appUserCards()}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'app-user-list' }}
  />

  const wrapper_full = () => <Wrapper
    content={wrapper_appUserCards()}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'app-user-list' }}
  />

  const handleSearchChange = (searchValue) => {
    if (!_.isEmpty(searchValue) && searchValue !== ' ') {
      const f = _.filter(currentProfiles, function (i) {
        return (searchValue && i.lastName && i.lastName.toLowerCase().startsWith(searchValue.toLowerCase())) ||
          (searchValue && i.firstName && i.firstName.toLowerCase().startsWith(searchValue.toLowerCase()));
      });
      setSelectedFilteredDataList(f)
    } else {
      setSelectedFilteredDataList()
    }
  }

  const searchHeader = () => <div className={'search-page'}><UiSearchFilter handleSearchChange={handleSearchChange} /></div>

  const content_counts = () => <SquaresAppUsers
    adminProfiles={adminProfiles}
    attendeeCounts={_counts}
    authOn={authOn}
    currentDataItems={fullData}
    handle_onFileDrop={handle_onFileDrop}
    hc_appUsers={hc_appUsers}
    hc_options={hc_options}
    itemCount={itemCount}
    nonProfiledAttendees={nonProfiledAttendees}
    selectedListType={selectedListType}
  />

  const wrapper_counts = () => <Wrapper
    header={'App Users'}
    content={content_counts()}
    updating={processing}
    wrapperType={wrapperTypes.padded}
  />

  const footer_appUsers = () => {
    const btns = []
    switch (selectedListType) {
      case _appUserDashboardTypes.notFound:
        btns.push({ oc: handle_removeNonFound, caption: 'Remove Non Found Profiles', icon: 'save', color: 'green', disabled: _.isEmpty(currentData) })
        break;
      case _appUserDashboardTypes.nonProfiled:
        btns.push({ oc: handle_updateNonProfiled, caption: 'Update Non Profiled', icon: 'save', color: 'green', disabled: _.isEmpty(nonProfiledAttendees) })
        break;
      case _appUserDashboardTypes.missingEvent:
      case _appUserDashboardTypes.missingProfile:
        btns.push({ oc: handle_updateNonEvents, caption: 'Update Non Event Profiles', icon: 'save', color: 'green', disabled: _.isEmpty(nonEventProfiles) })
        break;
      case _appUserDashboardTypes.photoSourced:
        btns.push({ handleUploadProfileImages, caption: 'Update Profile Images', icon: 'save', color: _allowUpload ? 'teal' : 'green', disabled: _.isEmpty(nonEventProfiles) })
        break;
    }
    return <UiSaveButtons others={btns} />
  }

  const content_appUsers = () => {
    if (showAlpha) {
      return wrapper_alpha()
    } else {
      return wrapper_full()
    }
  }

  const wrapper_contentAppUsers = () => <Wrapper
    header={`App Users - ${_.startCase(selectedListType)}`}
    search={showSearch && searchHeader()}
    content={content_appUsers()}
    footer={footer_appUsers()}
    wrapperType={wrapperTypes.padded}
    updating={updatingProfiles}
  />

  const header_appUser = () => {
    const caption = currentAppUser?.lastName ? `App User - ${currentAppUser?.lastName}` : 'App User'
    return <div>{caption}<Icon name='delete' style={{ float: 'right' }} onClick={() => { handleAppUser() }} /></div>
  }

  const wrapper_contentAppUser = () => <Wrapper
    header={header_appUser()}
    content={currentAppUser ? appUserCard(currentAppUser) : <div></div>}
    // footer={footer_appUsers()}
    wrapperType={wrapperTypes.padded}
    updating={updatingProfiles}
  />

  const onDragStart = (e, imageFile) => {
    draggingImageRef.current = imageFile
  };

  const imageList = () => <div style={{ display: 'flex', gap: '.5em', flexWrap: 'wrap' }}>
    {_.map(fileInfos?.allDroppedFiles, (df) => (
      <div>
        <Image
          src={df.src}
          size='tiny'
          title={df.name}
          onDragStart={(e) => onDragStart(e, df)}
        />
        <div style={{ fontSize: '.7rem', textAlign: 'center', padding: '.2em' }}>{df?._dataItem?.displayName || ''}</div>
      </div>
    ))}
  </div>

  const wrapper_images = () => <Wrapper
    header={<div style={{ display: 'flex', justifyContent: 'space-between' }}><div>Images</div><div><Icon name='delete' color='red' onClick={handleClear} /></div></div>}
    content={imageList()}
    wrapperType={wrapperTypes.padded}
  />

  const hc_selectedIndex = (s) => {
    s === 0 && setSelectedListType()
  }

  const wvc = () => {
    if (!_.isEmpty(currentImageFiles) || !_.isEmpty(currentImageDroppedFiles)) {
      return <WrapperVertCols mvc={'aud-4'} split={!fromDataViewer || isSplit} handleSelectedIndex={hc_selectedIndex} selected_index={selectedListType ? 1 : 0}>
        {wrapper_counts()}
        {wrapper_contentAppUsers()}
        {wrapper_contentAppUser()}
        {wrapper_images()}
      </WrapperVertCols>
    } else {
      switch (selectedListType) {
        case _appUserDashboardTypes.total:
        case _appUserDashboardTypes.admins:
          if (currentAppUser) {
            return <WrapperVertCols mvc={'aud-3'} split={!fromDataViewer || isSplit} handleSelectedIndex={hc_selectedIndex} selected_index={selectedListType ? 1 : 0}>
              {wrapper_counts()}
              {wrapper_contentAppUsers()}
              {wrapper_contentAppUser()}
            </WrapperVertCols>
          } else {
            return <WrapperVertCols mvc={'aud-2'} split={!fromDataViewer || isSplit} handleSelectedIndex={hc_selectedIndex} selected_index={selectedListType ? 1 : 0}>
              {wrapper_counts()}
              {wrapper_contentAppUsers()}
            </WrapperVertCols>
          }
        default:
          return <WrapperVertCols mvc={'aud-2'} split={!fromDataViewer || isSplit} handleSelectedIndex={hc_selectedIndex} selected_index={selectedListType ? 1 : 0}>
            {wrapper_counts()}
            {wrapper_contentAppUsers()}
          </WrapperVertCols>
      }
    }
  }

  if (!handleCancel && showConfirmation) {
    return <ConfirmationWrapper
      showConfirmation={showConfirmation}
      handleShow={handle_showConfirmation}
      // handleCommit={handle_updateSnapshot}
      allowCommit={true}
    />
  } else {
    if (handleCancel) {
      return wvc()
    } else {
      return wrapper_contentAppUsers()
    }
  }

}

export default AppUsersDashboard
